<template>
  <!-- All Modules -->
  <v-list dense class="background">
    <v-list-item v-for="(module, index) in modules" :key="index" class="nav-item" :class="`item-bottom-border`" link exact :to="buildRoute(module)">
      <nav-drawer-list-item-icon
        :unreadCountBadgeColor="theme.unreadBadgeColor"
        :isUnreadCountFeatureEnabled="mx_isUnreadCountFeatureEnabled(module.type, module.instance)"
        :iconColor="theme.elements.color"
        :invertImgIcons="theme.navDrawer.invertImgIcons"
        :module="module"
        :unreadCount="mx_unreadCount(module)"
      ></nav-drawer-list-item-icon>

      <nav-drawer-list-item-text>{{ $te(module.title) ? $t(module.title) : module.title }} </nav-drawer-list-item-text>

      <v-list-item-action>
        <v-btn icon @click="toggleQuickLink(module, $event)">
          <v-icon v-if="module.quickLink" :color="theme.navDrawer.headerBg">mdi-pin </v-icon>
          <!-- <v-icon v-else :color="darkMode ? '#808080' : '#404040'">mdi-pin-off-outline</v-icon> -->
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>
<script>
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';

import { mapState } from 'vuex';
import NavDrawerListItemIcon from './NavDrawerListItemIcon';
import NavDrawerListItemText from './NavDrawerListItemText';
import common from '@/mixins/common';

export default {
  name: 'ModuleList',
  mixins: [common, configMixin, navigationMixin],
  components: { NavDrawerListItemIcon, NavDrawerListItemText },

  data() {
    return {
      update: false,
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      userDisplayName: (state) => state.profile.user.userName,
      favorites: (state) => state.favorites.favorites,
    }),
  },

  methods: {
    toggleQuickLink(module, event) {
      event.preventDefault();
      module.quickLink = !module.quickLink;
      console.debug('toggled module to', module.quickLink);
      this.$forceUpdate();
      this.update = !this.update;
    },
  },
};
</script>
<style scoped>
.tabHeader,
.font > label {
  font-size: 10px;
}

.nav-item {
  height: 50px;
  padding-left: 20px;
  margin-top: 0;
  margin-bottom: 0;
}

.tabs-header-wrapper,
.tabs-header-sub-wrapper {
  position: absolute;
  padding-bottom: 0px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

#navTabs .v-slide-group__prev .v-slide-group__prev--disabled {
  width: 0 !important;
}
</style>
